import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import TextInput from '../../../components/ui/TextInput'
import FormDialog from '../../../components/ui/FormDialog'
import FormTextField from '../../../components/ui/form/FormTextField'
import { useZodForm } from '../../../lib/forms/useZodForm'
import { referansFormSchema, type ReferansFormValues } from './referansFormSchema'
import type { ReferansItem } from '../types'

interface Props {
  visible: boolean
  initial: ReferansItem | null
  submitting: boolean
  onSubmit: (nameTr: string, nameEn: string | null) => void
  onHide: () => void
}

/** Referans ad düzenleme (020: react-hook-form + zod; 018 davranışı) — Ad (TR/EN); Tip salt-okuma. */
export default function ReferansFormDialog({ visible, initial, submitting, onSubmit, onHide }: Readonly<Props>) {
  const { t } = useTranslation()
  const { control, handleSubmit, reset } = useZodForm(referansFormSchema, {
    defaultValues: { nameTr: '', nameEn: '' },
  })

  useEffect(() => {
    if (visible) reset({ nameTr: initial?.nameTr ?? '', nameEn: initial?.nameEn ?? '' })
  }, [visible, initial, reset])

  const onValid = (v: ReferansFormValues) => onSubmit(v.nameTr, v.nameEn ? v.nameEn : null)

  return (
    <FormDialog
      visible={visible}
      header={t('admin.referans.form.editTitle')}
      submitLabel={t('admin.referans.form.save')}
      submitting={submitting}
      submitDisabled={submitting}
      onSubmit={handleSubmit(onValid)}
      onHide={onHide}
    >
      <div className="admin-form">
        <div className="admin-field">
          <label>{t('admin.referans.form.type')}</label>
          <TextInput value={initial?.type ?? ''} disabled />
        </div>
        <FormTextField control={control} name="nameTr" label={t('admin.referans.form.nameTr')} required autoFocus />
        <FormTextField control={control} name="nameEn" label={t('admin.referans.form.nameEn')} />
      </div>
    </FormDialog>
  )
}
